import i18next from "i18next";
import { custom, success } from "./utilities";
import { setLocalStorageItem, setSessionStorageItem } from "../../system";
import { ToastifyService, subscriptionService } from "../../services";
import {
  StorageKeys,
  subscriptionConstants,
  translationConstants,
  globalSystemConstants,
  UserVerificationApprovalStatus,
} from "../../constants";

const { SUBSCRIPTION_PRICES } = subscriptionConstants;

export const GetAllSubscriptionPrices = ({ isLoading }) => {
  return (dispatch) => {
    if (isLoading) {
      dispatch(
        custom(SUBSCRIPTION_PRICES, globalSystemConstants.SPINNER_ACTIVATE)
      );
    }

    subscriptionService
      .getSubscriptionPrices()
      .then((response) => dispatch(success(response.data, SUBSCRIPTION_PRICES)))
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        if (isLoading) {
          dispatch(
            custom(
              SUBSCRIPTION_PRICES,
              globalSystemConstants.SPINNER_DEACTIVATE
            )
          );
        }
      });
  };
};

export const updateSubscriptionPrices = (data) => {
  return (dispatch) => {
    dispatch(
      custom(SUBSCRIPTION_PRICES, globalSystemConstants.SPINNER_ACTIVATE)
    );
    subscriptionService
      .updateSubscriptionPrices(data)
      .then((response) => {
        if (response) {
          dispatch(success(response.data, SUBSCRIPTION_PRICES));
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(SUBSCRIPTION_PRICES, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const proceedPayment = (data, setShow) => {
  return (dispatch) => {
    dispatch(
      custom(SUBSCRIPTION_PRICES, globalSystemConstants.SPINNER_ACTIVATE)
    );
    subscriptionService
      .proceedPayment(data)
      .then((response) => {
        setShow(false);
        setLocalStorageItem(
          StorageKeys.freelanceStatus,
          UserVerificationApprovalStatus.Pending
        );
        ToastifyService.showSuccess(response);
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(SUBSCRIPTION_PRICES, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

export const SubscriptionActions = {
  GetAllSubscriptionPrices,
  updateSubscriptionPrices,
  proceedPayment,
};
